/* eslint-disable no-unused-vars */

import React from 'react';
import SingleValueWiget from 'components/widgets/SingleValueWidget';
import COQWidget from 'components/widgets/COQWidget';
import PieChartWidget from 'components/widgets/PieChartWidget';
import LineChartWidget from 'components/widgets/LineChartWidget';
import CandleChartWidget from 'components/widgets/CandleChartWidget';
import SingleValueWigetOptions from 'components/widgets/SingleValueWidgetOptions';
import LineChartWigetOptions from 'components/widgets/LineChartWidgetOptions';

/***
 * Widget Register: Mapping between widgets and actual react components. New widgets should be defined here.
 */
export const widgetRegister = [
  {
    type: 'SingleValue',
    name: 'Single Value',
    description: 'Displays a single value',
    cssClass: 'widget-re',
    options: (state, onChange) => {
      return (
        <SingleValueWigetOptions
          state={state}
          onChange={onChange}
        ></SingleValueWigetOptions>
      );
    },
    component: (widget, data, options) => {
      return (
        <SingleValueWiget widget={widget} data={data} options={options}></SingleValueWiget>
      );
    }
  },
  {
    type: 'SingleValuePercent',
    name: 'Single Value And Percentage',
    description: 'Displays a numeric value alongsite a percentage value.',
    cssClass: 'widget-sm',
    component: data => {
      return <>Widget Unimplemented</>;
    }
  },
  {
    type: 'PieChart',
    name: 'Pie Chart',
    description: 'Displays a Pie chart',
    cssClass: 'widget-sm',
    component: (widget, data) => {
      return <PieChartWidget widget={widget} data={data}></PieChartWidget>;
    }
  },
  {
    type: 'BarChart',
    name: 'Bar Chart',
    description: 'Displays a Bar chart',
    cssClass: 'widget-sm',
    component: data => {
      return <>Widget Unimplemented</>;
    }
  },
  {
    type: 'LineChart',
    name: 'LineChart',
    description: 'Displays a Line chart',
    cssClass: 'widget-re',
    options: (state, onChange) => {
      return (
        <LineChartWigetOptions
          state={state}
          onChange={onChange}
        ></LineChartWigetOptions>
      );
    },
    component: (widget, data, options) => {
      return <LineChartWidget widget={widget} data={data} options={options}></LineChartWidget>;
    }
  },
  {
    type: 'Table',
    name: 'Table',
    description: 'Displays a table',
    cssClass: 'widget-sm',
    component: data => {
      return <>Widget Unimplemented</>;
    }
  },
  {
    type: 'COQ',
    name: 'Cost of Quality',
    description: 'CSO Cost of quality',
    cssClass: 'widget-lg',
    component: (widget, data) => {
      return <COQWidget widget={widget} data={data}></COQWidget>;
    }
  },
  {
    type: 'Candle',
    name: 'Candle Chart',
    description: 'Candle chart',
    cssClass: 'widget-lg',
    options: (state, onChange) => {
      return (
        <></>
      );
    },
    component: (widget, data) => {
      return <CandleChartWidget widget={widget} data={data}></CandleChartWidget>;
    }
  }
];
